import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import { formatDate } from "../../utils/formatDate";
import { useGetChangeActionsDate } from "../../hooks/useCrm";
import { useResetRecoilState } from "recoil";
import { crmActionCheckListAtom } from "../../shared/crm-action-checklist";

export const ChangeActivityDateModal = ({ show, handleClose, dates }) => {
  const [form, setForm] = useState({
    IdChange: null,
    DateChange: null,
  });
  useEffect(() => {
    setForm({ ...form, IdChange: dates });
  }, [dates]);
  const resetDates = useResetRecoilState(crmActionCheckListAtom);
  const [button] = useState(false);
  const { mutateAsync: ChangeDate, isLoading: ChangingDate } =
    useGetChangeActionsDate();
  const handleChange = async (dates) => {
    await ChangeDate(dates).then(() => {
      resetDates();
      setForm({ ...form, DateChange: null });
    });
  };

  return (
    <BootstrapModal
      modaltitle="تغییر تاریخ فعالیت ها"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={() => {
            setForm();
            handleClose();
          }}
        >
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <DataPicker
            label="انتخاب تاریخ"
            onChange={(e) => setForm({ ...form, DateChange: formatDate(e) })}
          />
        </div>
        <div className="col-6">
          <Button
            className=""
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleChange(form);
              handleClose();
            }}
          >
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button
            className=""
            bgColor="#f1416c"
            color="#fff"
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
